import Localization from '~/client/src/shared/localization/LocalizationManager'
import ProjectDateStore from '~/client/src/shared/stores/ui/ProjectDate.store'

import { DateRange, DateRangeType } from '../types/Widgets'

export const getDateRangeOptions = () => [
  { label: Localization.translator.oneDay, value: DateRangeType.OneDay },
  { label: Localization.translator.week, value: DateRangeType.Week },
  { label: Localization.translator.twoWeeks, value: DateRangeType.TwoWeeks },
  {
    label: Localization.translator.threeWeeks,
    value: DateRangeType.ThreeWeeks,
  },
  { label: Localization.translator.month, value: DateRangeType.Month },
  { label: Localization.translator.sixWeeks, value: DateRangeType.SixWeeks },
  {
    label: Localization.translator.threeMonths,
    value: DateRangeType.ThreeMonths,
  },
  { label: Localization.translator.year, value: DateRangeType.Year },
  { label: Localization.translator.project, value: DateRangeType.Project },
]

export function calculateDateRange(
  rangeType: DateRangeType,
  projectDateStore: ProjectDateStore,
  projectStartDate?: Date,
): DateRange {
  const now = new Date()
  let end = projectDateStore.endOfDay(now)
  let start: Date | null

  switch (rangeType) {
    case DateRangeType.OneDay:
      start = projectDateStore.startOfDay(now)
      break
    case DateRangeType.Week:
      start = projectDateStore.startOfDay(projectDateStore.addWeeks(now, -1))
      break
    case DateRangeType.TwoWeeks:
      start = projectDateStore.startOfDay(projectDateStore.addWeeks(now, -2))
      break
    case DateRangeType.ThreeWeeks:
      start = projectDateStore.startOfDay(projectDateStore.addWeeks(now, -3))
      break
    case DateRangeType.Month:
      start = projectDateStore.startOfDay(projectDateStore.addMonths(now, -1))
      break
    case DateRangeType.SixWeeks:
      start = projectDateStore.startOfDay(projectDateStore.addWeeks(now, -6))
      break
    case DateRangeType.ThreeMonths:
      start = projectDateStore.startOfDay(projectDateStore.addMonths(now, -3))
      break
    case DateRangeType.Year:
      start = projectDateStore.startOfDay(projectDateStore.addYears(now, -1))
      break
    case DateRangeType.Project:
      start = projectStartDate
        ? projectDateStore.startOfDay(projectStartDate)
        : null
      end = new Date(2100, 0, 1)
      break
    default:
      start = projectDateStore.startOfDay(projectDateStore.addDays(now, -1))
  }

  return {
    start,
    end,
    type: rangeType,
  }
}

export function calculatePreviousPeriodDateRange(
  currentRange: DateRange,
  rangeType: DateRangeType,
  projectDateStore: ProjectDateStore,
): DateRange {
  const { start, end } = currentRange

  if (start === null) {
    return {
      start: null,
      end: end,
      type: rangeType,
    }
  }

  const durationMs = end.getTime() - start.getTime()
  const prevEnd = new Date(start.getTime() - 1)
  const prevStart = new Date(prevEnd.getTime() - durationMs)

  return {
    start: projectDateStore.startOfDay(prevStart),
    end: projectDateStore.endOfDay(prevEnd),
    type: rangeType,
  }
}
